import { Grid } from '@mui/material'

/**
 * Renders two scrollable containers next to each other filling up avaliable space
 * @category Common components
 * @extends TextField
 * @component
 * @returns {JSX.Element}
 * @property {JSX.Element} left Content of left container.
 * @property {JSX.Element} right Content of right container.
 * @property {number} maxHeight Height of the containers.
 */
export const TwoSidedScreen = ({ left, right, maxHeight, ...props }) => {
  return (
    <Grid
      container
      spacing={0}
      justifyContent='space-evenly'
      sx={{ height: maxHeight || '100%' }}
      className='two-side-scroll-container'
    >
      <Grid
        className='scrollable-content'
        item
        xs={6}
        sx={{ height: '100%', minHeight: '200px' }}
      >
        {left}
      </Grid>
      <Grid
        className='scrollable-content'
        item
        xs={6}
        sx={{ height: '100%', minHeight: '200px' }}
      >
        {right}
      </Grid>
    </Grid>
  )
}
